// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2_ONR","inputDescription":"styles_inputDescription__1H90U"};